/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateDocumentTemplateDto } from '../models/work-create-document-template-dto';
import { WorkDocumentTemplate } from '../models/work-document-template';
import { WorkDocumentTemplateSelectorEnum } from '../models/work-document-template-selector-enum';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateDocumentTemplateDto } from '../models/work-update-document-template-dto';
import { WorkUploadDocumentTemplateDto } from '../models/work-upload-document-template-dto';

@Injectable({ providedIn: 'root' })
export class WorkDocumentTemplatesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentTemplatesV2ControllerFindAllPaginated()` */
  static readonly DocumentTemplatesV2ControllerFindAllPaginatedPath = '/v2/document-templates/paginated';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplatesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>containertypeId</li>
     * <li>sortableRank</li>
     * <li>itemdocument</li>
     * <li>active</li>
     * <li>relatedStandardtaskId</li>
     * <li>prettyName</li>
     * <li>identifierName</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC' | 'itemdocument:ASC' | 'itemdocument:DESC' | 'active:ASC' | 'active:DESC' | 'relatedStandardtaskId:ASC' | 'relatedStandardtaskId:DESC' | 'prettyName:ASC' | 'prettyName:DESC' | 'identifierName:ASC' | 'identifierName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,prettyName,identifierName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>prettyName</li>
     * <li>identifierName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDocumentTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentTemplatesV2Service.DocumentTemplatesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkDocumentTemplate>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplatesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>containertypeId</li>
     * <li>sortableRank</li>
     * <li>itemdocument</li>
     * <li>active</li>
     * <li>relatedStandardtaskId</li>
     * <li>prettyName</li>
     * <li>identifierName</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC' | 'itemdocument:ASC' | 'itemdocument:DESC' | 'active:ASC' | 'active:DESC' | 'relatedStandardtaskId:ASC' | 'relatedStandardtaskId:DESC' | 'prettyName:ASC' | 'prettyName:DESC' | 'identifierName:ASC' | 'identifierName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,prettyName,identifierName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>prettyName</li>
     * <li>identifierName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkDocumentTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}> {
    return this.documentTemplatesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDocumentTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkDocumentTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `documentTemplatesV2ControllerDownloadDocumentTemplate()` */
  static readonly DocumentTemplatesV2ControllerDownloadDocumentTemplatePath = '/v2/document-templates/download-template';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplatesV2ControllerDownloadDocumentTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerDownloadDocumentTemplate$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentTemplatesV2Service.DocumentTemplatesV2ControllerDownloadDocumentTemplatePath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplatesV2ControllerDownloadDocumentTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerDownloadDocumentTemplate(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentTemplatesV2ControllerDownloadDocumentTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentTemplatesV2ControllerGetTemplatesByContainerStatusSelector()` */
  static readonly DocumentTemplatesV2ControllerGetTemplatesByContainerStatusSelectorPath = '/v2/document-templates/templatesByContainerStatusSelector';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplatesV2ControllerGetTemplatesByContainerStatusSelector()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerGetTemplatesByContainerStatusSelector$Response(
    params?: {

    /**
     * Optional: Filter templates by containertype ID
     */
      containertypeId?: number;

    /**
     * Optional: Filter templates by status ID
     */
      statusId?: number;

    /**
     * Optional: Filter templates by selector (can be used multiple times)
     */
      selector?: Array<WorkDocumentTemplateSelectorEnum>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocumentTemplate>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentTemplatesV2Service.DocumentTemplatesV2ControllerGetTemplatesByContainerStatusSelectorPath, 'get');
    if (params) {
      rb.query('containertypeId', params.containertypeId, {});
      rb.query('statusId', params.statusId, {});
      rb.query('selector', params.selector, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocumentTemplate>>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplatesV2ControllerGetTemplatesByContainerStatusSelector$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerGetTemplatesByContainerStatusSelector(
    params?: {

    /**
     * Optional: Filter templates by containertype ID
     */
      containertypeId?: number;

    /**
     * Optional: Filter templates by status ID
     */
      statusId?: number;

    /**
     * Optional: Filter templates by selector (can be used multiple times)
     */
      selector?: Array<WorkDocumentTemplateSelectorEnum>;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocumentTemplate>> {
    return this.documentTemplatesV2ControllerGetTemplatesByContainerStatusSelector$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocumentTemplate>>): Array<WorkDocumentTemplate> => r.body)
    );
  }

  /** Path part for operation `documentTemplatesV2ControllerFindById()` */
  static readonly DocumentTemplatesV2ControllerFindByIdPath = '/v2/document-templates/{id}';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplatesV2ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerFindById$Response(
    params: {
      id: number;
      withTasks?: any;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocumentTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentTemplatesV2Service.DocumentTemplatesV2ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('withTasks', params.withTasks, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocumentTemplate>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplatesV2ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerFindById(
    params: {
      id: number;
      withTasks?: any;
    },
    context?: HttpContext
  ): Observable<WorkDocumentTemplate> {
    return this.documentTemplatesV2ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocumentTemplate>): WorkDocumentTemplate => r.body)
    );
  }

  /** Path part for operation `documentTemplatesV2ControllerDelete()` */
  static readonly DocumentTemplatesV2ControllerDeletePath = '/v2/document-templates/{id}';

  /**
   * Required permissions: documents:delete, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplatesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentTemplatesV2Service.DocumentTemplatesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: documents:delete, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplatesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplatesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.documentTemplatesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `documentTemplatesV2ControllerUpdate()` */
  static readonly DocumentTemplatesV2ControllerUpdatePath = '/v2/document-templates/{id}';

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplatesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplatesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateDocumentTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentTemplatesV2Service.DocumentTemplatesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplatesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplatesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateDocumentTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.documentTemplatesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `documentTemplatesV2ControllerCreate()` */
  static readonly DocumentTemplatesV2ControllerCreatePath = '/v2/document-templates';

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplatesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplatesV2ControllerCreate$Response(
    params: {
      body: WorkCreateDocumentTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocumentTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentTemplatesV2Service.DocumentTemplatesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocumentTemplate>;
      })
    );
  }

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplatesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplatesV2ControllerCreate(
    params: {
      body: WorkCreateDocumentTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkDocumentTemplate> {
    return this.documentTemplatesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocumentTemplate>): WorkDocumentTemplate => r.body)
    );
  }

  /** Path part for operation `documentTemplatesV2ControllerUploadFile()` */
  static readonly DocumentTemplatesV2ControllerUploadFilePath = '/v2/document-templates/upload-file';

  /**
   * Required permissions: documents:update, documents:create, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplatesV2ControllerUploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentTemplatesV2ControllerUploadFile$Response(
    params: {
      body: WorkUploadDocumentTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentTemplatesV2Service.DocumentTemplatesV2ControllerUploadFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: documents:update, documents:create, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplatesV2ControllerUploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentTemplatesV2ControllerUploadFile(
    params: {
      body: WorkUploadDocumentTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.documentTemplatesV2ControllerUploadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
